import apis from './apis';
import to from 'await-to-js';
import { DOMParser as XMLParser } from 'xmldom';
import user from './user';
import browser from './browser';
import cdnHandler from './CDNHandler';
interface ErrorObject {
    description: string;
    [key: string]: string;
}

/**
 * Function to handle restrictions in the XML response.
 * @param errNode
 * @returns {object}
 */
const _handleRestrictions = (errNode: Element): { error: ErrorObject } => {
    const error: ErrorObject = {
        description: errNode.getAttribute('abstract') || '',
    };
    const params = errNode.getElementsByTagName('param');
    for (let i = 0; i < params.length; i++) {
        const param = params[i];
        error[param.getAttribute('name') || ''] = param.getAttribute('value') || '';
    }

    if (error.exception) {
        error.exception = 'BR_' + error.exception;
    }
    return { error };
};

const SMILHandler = {
    /**
     * Function to parse XML response and extract video URL.
     * @param response
     * @returns {string | object}
     */
    parseXML: (response: string): string | { error: ErrorObject } => {
        let videoUrl = '';
        if (!response) return videoUrl;

        const doc = new XMLParser().parseFromString(response, 'text/xml');
        let ref;
        if (doc) {
            const seqElement = doc.getElementsByTagName('seq')[0];
            ref = seqElement && seqElement.getElementsByTagName('ref')[0];
        }

        if (ref) {
            return _handleRestrictions(ref);
        }

        const videoElement = doc.getElementsByTagName('video')[0];
        videoUrl = videoElement ? videoElement.getAttribute('src') || '' : '';
        videoUrl = videoElement ? videoElement.getAttribute('src') || '' : '';
        if (!videoUrl) {
            return {
                error: {
                    description: '',
                    exception: 'BR_EmptyStream',
                },
            };
        }
        videoUrl = videoUrl[videoUrl.length - 1] === '}' ? videoUrl.slice(0, -1) : videoUrl;
        return videoUrl;
    },
    /**
     * Function to resolve URL by making an API call and parsing the response.
     * @param url
     * @returns {Promise<string>}
     */
    resolveUrl: async (url: string, token?: string): Promise<string> => {
        const authObj = user.getUserInfo();
        let error;
        let response: any = null;
        const params = {
            format: 'SMIL',
            switch: browser.isSafari() ? 'fairplay' : 'dash',
            clientId: authObj.guid,
            auth: authObj.authToken || authObj.token,
            accountId: authObj.username,
        };
        if (url.indexOf('?') === -1) {
            url += '?';
        }
        for (const param in params) {
            url += `&${param}=${params[param]}`;
        }
        if (/^http[^s]/g.test(url)) {
            url = url.replace('http', 'https');
        }
        [error, response] = await to(apis.callApi(url, null, 'GET', {}, { responseJson: false }));
        if (response) {
            let output = SMILHandler.parseXML ? SMILHandler.parseXML(response) : null;
            if (output === null) {
                throw new Error('Failed to parse XML');
            }
            if (typeof output === 'object' && 'error' in output) {
                throw output.error;
            }
            [error, output] = await to(cdnHandler.resolveTrailerUrl(output as string, token));
            if (error) {
                throw error;
            }
            return output as string;
        }
        throw new Error('Failed to resolve URL');
    },
};

export default SMILHandler;
